/**
 * Requisition Model - Processes API responses for requisition data
 */

export const getRequisitions = (response) => {
  if (response && response.data && response.data.success === true) {
    const requisitions = Array.isArray(response.data.data)
      ? response.data.data.map((r) => ({
          id: r.id || null,
          slack: r.slack || '',
          requisition_number: r.requisition_number || '',
          requisition_reference: r.requisition_reference || '',
          requisition_date: r.requisition_date || '',
          requisition_due_date: r.required_by_date || '',
          created_at: r.created_at || '',
          updated_at: r.updated_at || '',
          createdAt: r.createdAt || r.created_at || '',
          updatedAt: r.updatedAt || r.updated_at || '',
          created_by: r.created_by || '',
          updated_by: r.updated_by || '',
          priority: r.priority || '',
          purpose: r.purpose || '',
          department: r.department || '',
          total_estimated_amount: r.total_estimated_amount || '0',
          approval_status: r.approval_status ?? 0,
          products_count: r.products_count ?? 0,
          store_name: r.store_name || '',
          place_holder1: r.place_holder1 || null,
          place_holder2: r.place_holder2 || null,
          place_holder3: r.place_holder3 || null,
          place_holder4: r.place_holder4 || null,
          place_holder5: r.place_holder5 || null,
          status_data: r.status_data ? {
            label: r.status_data.label || '',
            value_constant: r.status_data.value_constant || '',
            color: r.status_data.color || ''
          } : null,
          status_label: r.status_data ? {
            label: r.status_data.label || '',
            value_constant: r.status_data.value_constant || '',
            color: r.status_data.color || ''
          } : null,
          menu_options: Array.isArray(r.menu_options) ? r.menu_options : []
        }))
      : []

    return {
      success: true,
      total: response.data.total || requisitions.length,
      data: requisitions
    }
  }
  return {
    success: false,
    message: response?.data?.message || 'Failed to fetch requisition list',
    data: []
  }
}

export const deleteRequisition = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Requisition deleted successfully'
    }
  }
  return {
    success: false,
    message: 'Failed to delete requisition'
  }
}

export const createRequisition = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Requisition created successfully',
      data: response.data.data || null
    }
  }
  return {
    success: false,
    message: 'Failed to create requisition',
    data: null
  }
}

export const updateRequisition = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Requisition updated successfully',
      data: response.data.data || null
    }
  }
  return {
    success: false,
    message: 'Failed to update requisition',
    data: null
  }
}


export const fetchStoreHierarchy = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Store hierarchy fetched successfully',
      data: response.data.data || null
    }
  }
  return {
    success: false,
    message: 'Failed to fetch store hierarchy',
    data: null
  }
}
